// Copyright (C) 2024 CVAT.ai Corporation
//
// SPDX-License-Identifier: MIT

import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { Row, Col } from 'antd/lib/grid';
import Button from 'antd/lib/button';
import Tooltip from 'antd/lib/tooltip';
import { PlusOutlined } from '@ant-design/icons';
import dimensions from 'utils/dimensions';
import { CombinedState } from 'reducers';
import CreateRunModal from './create-run-modal';

export default function TopBarComponent(): JSX.Element {
    const [modalVisible, setModalVisible] = useState(false);
    const user = useSelector((state: CombinedState) => state.auth.user);
    const canManage = !!user && (user.isSuperuser || user.isStaff || user.groups.includes('admin'));

    return (
        <Row className='cvat-labeling-runs-page-top-bar' justify='center' align='middle'>
            <Col {...dimensions}>
                <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                    <Tooltip title={canManage ? '' : 'You do not have permission to create runs'}>
                        <span>
                            <Button
                                type='primary'
                                icon={<PlusOutlined />}
                                disabled={!canManage}
                                onClick={() => setModalVisible(true)}
                            >
                                Create Run
                            </Button>
                        </span>
                    </Tooltip>
                </div>
            </Col>
            <CreateRunModal visible={modalVisible} onClose={() => setModalVisible(false)} />
        </Row>
    );
}
